import "./IssueDataTable.scss";

import IssueDataTable from "./IssueDataTable";

export default IssueDataTable;
